import { render, staticRenderFns } from "./SpecialContentItem.vue?vue&type=template&id=74064590&scoped=true"
import script from "./SpecialContentItem.vue?vue&type=script&lang=js"
export * from "./SpecialContentItem.vue?vue&type=script&lang=js"
import style0 from "./SpecialContentItem.vue?vue&type=style&index=0&id=74064590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74064590",
  null
  
)

export default component.exports